// @flow

const RowNumberColumn = (props: Object) => {
    const { page, index, pageSize } = props;

    const offset = page * pageSize;

    return offset + index + 1;
};

export default RowNumberColumn;
